import { jwtDecode } from "jwt-decode";
import { useEffect } from "react";
import { IEmloyeeData } from "../utils/types";
import { useNavigate } from "react-router-dom";
import useLogin from "../hooks/useLogin";
import { useGetCheckLoginAccessMutation, vendorApi } from "../services/vendor/VendorApi";
import { toast } from "react-toastify";
import { billsApi } from "../services/bills/BillsApiSlice";
import { landingPageApi, useGetEmployeeLogoutMutation, useGetEmployeeSessionMutation } from "../services/invoices/InvoiceApiSlice";
import { authApi } from "../services/auth/authApiSlice";
import { useDispatch } from "react-redux";
import { SSO_BASE_URL } from "../utils/constants";

const SSOPage = () => {
  const navigate = useNavigate();
  const { handleSSOLogin } = useLogin();
  const [getCheckLoginAccess] = useGetCheckLoginAccessMutation();
  const [getCheckEmployeeSession] = useGetEmployeeSessionMutation();
  const [getSessionLogout] = useGetEmployeeLogoutMutation();
  const dispatch = useDispatch();

  useEffect(() => {
    const handleEmployeeLoginViaToken = async () => {

      const params = new URLSearchParams(window.location.search);
      const token = params.get("token");

      if (token) {
        try {
          const user: IEmloyeeData = jwtDecode(token);

          const payload = { user_id: user?.userId, user_type: "EMPLOYEE" };

          const response = await getCheckLoginAccess(payload);

          if (response?.data?.allowed) {
            localStorage.setItem("authToken", token);
            localStorage.setItem("userRole", "employee");

            localStorage.setItem("employee_id", String(user?.userId));
            localStorage.setItem("employee_name", String((user?.givenName || '') + " " + (user?.familyName || '')));
            document.body.classList.add("Login");
            forceToLogin(false);

            setTimeout(() => {
              navigate("/employee_landing_page");
            }, 200);

          } else {
            toast.error(response?.data?.message)
            dispatch(billsApi.util.resetApiState());
            dispatch(landingPageApi.util.resetApiState());
            dispatch(authApi.util.resetApiState());
            dispatch(vendorApi.util.resetApiState());

            localStorage.clear();
            window.history.pushState(null, window.location.pathname);
            window.location.replace(`${SSO_BASE_URL}/logout`);
          }
        } catch (error) {
          localStorage.clear();
          handleSSOLogin();
        }
      } else {
        localStorage.clear();
        handleSSOLogin();
      }
    };
    if (localStorage.getItem("authToken") === null) {
      handleEmployeeLoginViaToken();
    }
  }, []);

  const forceToLogin = async (force_login: boolean) => {

    try {
      const response: any = await getCheckEmployeeSession({ force_login });
      if (response?.error?.data?.code === "ACTIVE_SESSION_EXISTS") {
        var isLoginAlready = window.confirm(response?.error?.data?.message);
        if (isLoginAlready) {
          forceToLogin(true);
        } else {

          await getSessionLogout({});
          dispatch(billsApi.util.resetApiState());
          dispatch(landingPageApi.util.resetApiState());
          dispatch(authApi.util.resetApiState());
          dispatch(vendorApi.util.resetApiState());

          window.history.pushState(null, window.location.pathname);
          window.location.replace(`${SSO_BASE_URL}/logout`);
          setTimeout(() => {
            localStorage.clear();
          }, 1000);
        }
      }
    } catch (err) {

    }
  }
  return <p>Logging you in...</p>;
};

export default SSOPage;
